// Enhanced version (optional — replace the above if you like this better)
import React from 'react';
import { Box, Typography } from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';

const NoDataMessage = ({ message = "No Activity Recorded", subtext = "Data will appear here once available" }) => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#D1D5DB',
      }}
    >
      {/* <TimelineIcon sx={{ fontSize: 64, mb: 3, opacity: 0.4, color: '#8B5CF6' }} /> */}
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#E8D0FF' }}>
        {message}
      </Typography>
      <Typography variant="body2" sx={{ mt: 1, opacity: 0.7 }}>
        {subtext}
      </Typography>
    </Box>
  );
};

export default NoDataMessage;